function databaseIntToBool(number) {
    let bool = false;
    if(number === 1) {
        bool = true;
    }
    return bool;
}

export default databaseIntToBool